var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v(_vm._s(_vm.data.fields.heading))]),_c('ul',{staticClass:"steps"},_vm._l((_vm.data.fields.howToApplyStep),function(step,i){return _c('li',{key:i},[_c('document-renderer',{attrs:{"documentId":step.sys.id,"additionaldata":{ stepCount: i }}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }